import { render, staticRenderFns } from "./Bedrijf.vue?vue&type=template&id=2f9c3c7c&scoped=true&"
import script from "./Bedrijf.vue?vue&type=script&lang=js&"
export * from "./Bedrijf.vue?vue&type=script&lang=js&"
import style0 from "./Bedrijf.vue?vue&type=style&index=0&id=2f9c3c7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9c3c7c",
  null
  
)

export default component.exports